import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import { Grid, Typography, Stack } from "@mui/material";
import AdminDrawer from "../../components/AdminDrawer";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import { getAllServiceProviders } from "../../apis";
import UserInfoCard from "./components/UserInfoCard";

const AllServiceProviders = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllServiceProviders();
      setUsers(response.data.userInfo);
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <>
      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="All Service Providers" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={9}>
                <Typography className="mb-16" variant="h6">
                  All Service Providers
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {users.length && loading == false ? (
                      users.map((item) => (
                        <>
                          <UserInfoCard
                            title={item.serviceProvider.fullName}
                            email={item.serviceProvider.email}
                          />
                        </>
                      ))
                    ) : users.length == 0 && loading == false ? (
                      <>
                        <Typography>No Service Providers Found</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AllServiceProviders;
